import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import Chppy from '../Bot/Chppy.js';
import logo from '../../assets/logo.png';
import navLinks from '../../config/nav';

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isShrunk, setIsShrunk] = useState(false);
  const location = useLocation();

  // header variant per route: transparent on home (hero), solid elsewhere
  const variant = location.pathname === '/' ? 'header--transparent' : 'header--solid';

  const toggleDrawer = () => setDrawerOpen(prev => !prev);
  const closeDrawer = () => setDrawerOpen(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onScroll = () => setIsShrunk(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // close drawer when route changes
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  // expose header height as a CSS variable for layout consumers
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    // read initial values from CSS so JS doesn't hard-code fallbacks
    const initial = getComputedStyle(root).getPropertyValue('--header-height').trim() || '64px';
    const shrinkVal = getComputedStyle(root).getPropertyValue('--header-height-shrink').trim() || '52px';
    root.style.setProperty('--header-height', isShrunk ? shrinkVal : initial);
  }, [isShrunk]);

  return (
    <>
      <header className={`header ${isShrunk ? 'shrink' : ''} ${variant}`}>
        <div className="header-left">
          <Link to="/" aria-label="Rippluence home">
            <img src={logo} alt="Rippluence" className="header-logo" />
          </Link>
        </div>

        <div className="header-container">
          <button
            className="menu-button"
            onClick={toggleDrawer}
            aria-expanded={drawerOpen}
            aria-controls="site-drawer"
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>
      </header>
    

  {drawerOpen && <div data-testid="overlay" className="overlay" onClick={closeDrawer} />}

  <aside data-testid="site-drawer" id="site-drawer" className={`drawer ${drawerOpen ? 'open' : ''}`} aria-hidden={!drawerOpen}>
        <div className="drawer-header">
          <img src={logo} alt="Rippluence Logo" className="drawer-logo" />
          <h2 className="drawer-title">Rippluence</h2>
        </div>

        <nav className="drawer-nav">
          {navLinks.map(l => (
            <Link key={l.to} to={l.to} className="drawer-link" onClick={closeDrawer}>{l.label}</Link>
          ))}
        </nav>

        <div className="chppy-container">
          <Chppy isVisible={drawerOpen} />
        </div>
      </aside>
    </>
  );
};

export default Header;
